import { Component, ElementRef } from '@angular/core'
import { RoutingService } from '@spartacus/core'
import {
  HamburgerMenuService,
  KeyboardFocusService,
  StorefrontComponent
} from '@spartacus/storefront'
import { EbBaseSiteService } from '../../features/site-context/services/eb-base-site.service'

@Component({
    selector: 'eb-storefront',
    templateUrl: './eb-storefront.component.html',
    standalone: false
})
export class EbStorefrontComponent extends StorefrontComponent {

  constructor(
    hamburgerMenuService: HamburgerMenuService,
    routingService: RoutingService,
    elementRef: ElementRef<HTMLElement>,
    keyboardFocusService: KeyboardFocusService,
    protected baseSiteService: EbBaseSiteService
  ) {
    super(hamburgerMenuService, routingService, elementRef, keyboardFocusService)
  }

  get isModalShown(): boolean {
    return document.getElementsByClassName('modal-open').length > 0
  }

}
